import { postChangeForgotPassword } from 'api/calls';
import clsx from 'clsx';
import { Button } from 'components/atoms'
import { ApiSimpleResponse, LoginResponse } from 'components/types';
import { LoginType } from 'components/types/Context';
import { ChangeForgotPWreq } from 'components/types/types';
import { useFormik } from 'formik';
import React, { FC, useContext, useState } from 'react'
import { useLocation } from 'react-router-dom';
import { AppGeneralContext } from 'shared/GeneralContext/GeneralContext';
import { code_regex } from 'shared/const';
import * as Yup from "yup";

export type CNPProps = {
    handleLoginResponse: (resp: ApiSimpleResponse<LoginResponse>, setSubmitting: (isSubmitting: boolean) => void, isStartUp: boolean)=> void,
    whoLogsIn: LoginType
}

export const ChooseNewPassword:FC<CNPProps> = ({handleLoginResponse,whoLogsIn}) => {

    const {
        setLoadingModal,
        forgotPWNewEmail,
      } = useContext(AppGeneralContext)


      
    const changeForgotPWSchema = Yup.object().shape({
        email: Yup.string()
          .required('Please complete this required field.'),
        code: Yup.string()
          .matches(code_regex, 'Format code not correct')
          .required('Please complete this required field.'),
        password: Yup.string().password()
          .required()
          .min(8, 'Password must contain 8 or more characters with at least one of each: uppercase, lowercase, number and special')
          .minLowercase(1, 'Password must contain at least 1 lower case letter')
          .minUppercase(1, 'Password must contain at least 1 upper case letter')
          .minNumbers(1, 'Password must contain at least 1 number')
          .minSymbols(1, 'Password must contain at least 1 special character'),
        confirmPassword: Yup.string().when("password", {
          is: (password: string) => password && password.length > 0,
          then: Yup.string()
            .oneOf([Yup.ref('password'), null], 'Passwords doesen\'t match')
            .required('Please complete this required field.'),
        }),
      });
    
      const formikChageForgotPW = useFormik<ChangeForgotPWreq>({
        initialValues: { email: forgotPWNewEmail , password: "", isStartup: whoLogsIn === LoginType.startup, code: "", confirmPassword: "" },
        validationSchema: changeForgotPWSchema,
        enableReinitialize: true,
    
        onSubmit: async (values, { setSubmitting }) => {
          setSubmitting(true)
          setLoadingModal();
          const req = {...values, code: values.code.toUpperCase()}
          const forgotPasswordResponse = await postChangeForgotPassword(req);
          handleLoginResponse(forgotPasswordResponse, setSubmitting, values.isStartup)
        }
    
      })


  return (
    <form onSubmit={formikChageForgotPW.handleSubmit} autoComplete='off' id='formChangeForgotPW' >

    <label className='text-black mt-3' htmlFor="password">Code</label>
    <input
      autoComplete="new-password"
      placeholder='Insert code'
      {...formikChageForgotPW.getFieldProps('code')}
      className="form-input"
      type="text"
      onChange={formikChageForgotPW.handleChange}
      onBlur={(e) => { e.target.value.length > 0 ? formikChageForgotPW.setFieldTouched("code", true) : formikChageForgotPW.setFieldTouched("code", false) }}
      value={formikChageForgotPW.values.code}
      name="code"
    />
    {formikChageForgotPW.errors.code && formikChageForgotPW.touched.code && <div className='text-error' id="password">{formikChageForgotPW.errors.code}</div>}

    <div className={formikChageForgotPW.values.code.length > 0 && !formikChageForgotPW.errors.code ? "" : "d-none"}>
      <label
        className={clsx('text-black mt-3')}
        htmlFor="password">Password</label>
      <input
        autoComplete='(suggested: "new-password")'
        placeholder='Password'
        {...formikChageForgotPW.getFieldProps('password')}
        className={clsx('form-input')}
        type="password"
        onChange={formikChageForgotPW.handleChange}
        onBlur={(e) => { e.target.value.length > 0 ? formikChageForgotPW.setFieldTouched("password", true) : formikChageForgotPW.setFieldTouched("password", false) }}
        value={formikChageForgotPW.values.password}
        name="password"
      />
      {formikChageForgotPW.errors.password && formikChageForgotPW.touched.password && <div className='text-error' id="password">{formikChageForgotPW.errors.password}</div>}

      <label className={clsx('text-black mt-3',
      )}
        htmlFor="confirmPassword">Confirm Password</label>
      <input
        autoComplete="new-password"
        placeholder='Confirm password'
        {...formikChageForgotPW.getFieldProps('confirmPassword')}
        className={clsx('form-input')}
        type="password"
        onChange={formikChageForgotPW.handleChange}
        onBlur={() => formikChageForgotPW.setFieldTouched("confirmPassword", true)}
        value={formikChageForgotPW.values.confirmPassword}
        name="confirmPassword"
      />
      {formikChageForgotPW.errors.confirmPassword && formikChageForgotPW.touched.confirmPassword && <div className='text-error' id="confirmPassword">{formikChageForgotPW.errors.confirmPassword}</div>}
      <Button form="formChangeForgotPW"
        type='submit'
        className='mt-5 ms-1 ' color='var(--white)' background='var(--primary)' borderColor='var(--primary)' fontWeight={'800'} uppercase primary text='submit' />
    </div>
  </form >
  )
}

